import { TemplateOverrides } from './template.overrides.request';
import { TrainingEmailEventTypes } from './training.email.event.types';

export class SendRealEmailsForTrainingEventRequest {
    TrainingEventID: number;
    TrainingEmailEventType: TrainingEmailEventTypes;
    TemplateOverrides: TemplateOverrides;
}
